import React, { useCallback, useEffect, useState } from 'react';
import { Navigate, Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import { CssBaseline } from '@mui/material';
import PrivateRoute from './PrivateRoute';
import http from './commonFunctions/httpClient';
import DashboardLayout from './Components/Dashboard/DashboardLayout';
import config from './Config/config.json';




const SESSION_TIMEOUT = config.sessionTimeOut * 60 * 1000; // e.g., 15 minutes

const App: React.FC = () => {
  const [token, setToken] = useState<string | null>("1234");
  const [lastActivity, setLastActivity] = useState<number>(Date.now());
  const [isAccessToLogin, setIsAccessToLogin] = useState(false); // fixed typo
 const tokenFromStorage = localStorage.getItem('token');
if (tokenFromStorage) {
  http.setAuthToken(tokenFromStorage);
}
  useEffect(() => {
    if (token) {
      http.setAuthToken(token);
    }
  }, [token]);

  useEffect(() => {
    if (!token) return;

    const handleActivity = () => {
      setLastActivity(Date.now());
    };

    window.addEventListener('mousemove', handleActivity);
    window.addEventListener('keydown', handleActivity);

    const checkTimeout = () => {
      if (Date.now() - lastActivity > SESSION_TIMEOUT) {
        handleLogout();
        window.location.reload();
      }
    };

    const intervalId = setInterval(checkTimeout, 1000);

    return () => {
      clearInterval(intervalId);
      window.removeEventListener('mousemove', handleActivity);
      window.removeEventListener('keydown', handleActivity);
    };
  }, [lastActivity, token]);

  const handleLogin = (newToken: string) => {
    setToken(newToken);
    localStorage.setItem('token', newToken);
    http.setAuthToken(newToken);
  };

  const handleLogout = useCallback(() => {
    setToken(null);
    localStorage.removeItem('token');
    http.setAuthToken(null);
  }, []);

  // Optional logic: set isAccessToLogin based on query param
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.get('access') === 'login') {
      setIsAccessToLogin(true);
    }
  }, []);

  return (
    <Router>
      <CssBaseline />

      {/* Always redirect to login if access flag is true */}
      {isAccessToLogin && <Navigate to="/login" replace />}

      <Routes>
        {/* Default route redirects based on token */}
        <Route path="/" element={<Navigate to={token ? "/dashboard" : "/login"} replace />} />

        {/* Public routes */}
      
        
        {/* <Route path="/logout" element={<Logout />} /> */}

        {/* Protected routes */}
        {/* <Route
          path="/dashboard"
          element={token ? <DashboardLayout /> : <Navigate to="/register" replace />}
        > */}
        <Route path="/" element={<DashboardLayout />   }>
          <Route path="*" element={<PrivateRoute token={token} />} />
        </Route>
      </Routes>
    </Router>
  );
};

export default App;
